import { handleActions } from 'redux-actions';
import * as actions from './actions';

const initial = {
  loading: false,
  error: null,
  data: {
    ENABLE_BILLOGRAM_INVOICES: false,
    ENABLE_STRIPE_CHECKOUT: false,
  },
  lastFetchedAt: null,
};

export default handleActions(
  {
    [actions.FETCH_FLAGS_REQUEST]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),

    [actions.FETCH_FLAGS_SUCCESS]: (state, { payload }) => ({
      ...state,
      loading: false,
      error: null,
      data: payload || state.data, // keep previous on empty payload
      lastFetchedAt: payload ? Date.now() : state.lastFetchedAt,
    }),

    [actions.FETCH_FLAGS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      loading: false,
      error,
    }),
  },
  initial,
);
